import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const when = (s?: string) => (s ? new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");

export function SignedInDevices() {
  const [rows, setRows] = useState<any[] | null>(null);
  const load = () => api.get("/me/devices").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const out = async (id?: string) => {
    if (!id && !window.confirm("Sign out of the Cast app on every phone?")) return;
    try { await api.delete(id ? `/me/devices/${id}` : "/me/devices"); toast.success(id ? "That phone is signed out" : "Signed out on all phones"); load(); }
    catch (e) { toast.error(errMsg(e)); load(); }
  };
  if (rows === null) return null;
  return (
    <section className="card-warm p-6 sm:p-8" data-testid="signed-in-devices">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="eyebrow">Signed-in phones</p>
        {rows.length > 1 && <Button variant="ghost" size="sm" data-testid="devices-sign-out-all" onClick={() => out()} className="text-[#C86D51]">Sign out all</Button>}
      </div>
      {rows.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500" data-testid="devices-empty">You're not signed in to the Cast app on any phone.</p>
      ) : (
        <ul className="mt-4 divide-y divide-[#E2DBCE]">
          {rows.map((d) => (
            <li key={d.id} className="flex items-center justify-between gap-4 py-4" data-testid={`device-${d.id}`}>
              <span className="flex items-center gap-3">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#F3ECE0] text-[#1E293B]"><Smartphone className="h-5 w-5" /></span>
                <span>
                  <span className="block font-semibold text-slate-900">{d.device}{d.this_device && <span className="ml-2 rounded-full bg-emerald-100 px-2 py-0.5 text-xs text-emerald-800">This phone</span>}</span>
                  <span className="text-sm text-slate-500">Signed in {when(d.signed_in)} · last used {when(d.last_used)}</span>
                </span>
              </span>
              <Button variant="outline" size="sm" data-testid={`device-sign-out-${d.id}`} onClick={() => out(d.id)} className="rounded-full">Sign out</Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
